import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ConfigService } from './config.service';
import { FileModel } from 'app/models/file.model';
import { QuestionnaireTemplateModel, QuestionnaireModel } from 'app/models/questionnaire.model';

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService {

  constructor(private api: HttpClient, private config: ConfigService) { }

  public GetQuestionnaireTemplates(): Observable<Array<QuestionnaireTemplateModel>> {
    return this.api.get<Array<QuestionnaireTemplateModel>>(this.config.getApiRoute('api/v3/client-portal/questionnaire-templates')).pipe(
      map(data => {
        return data;
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err.error.message)
      }));
  }


  public GetQuestionnaires(property_id: string): Observable<Array<QuestionnaireModel>> {
    return this.api.get<Array<QuestionnaireModel>>(this.config.getApiRoute('api/v3/client-portal/properties/' + property_id + '/questionnaires')).pipe(
      map(data => {
        return data;
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err.error.message);
      }));
  }

  public GetQuestionnaire(property_id: string,questionnaire_id: string): Observable<QuestionnaireModel> {
    return this.api.get<QuestionnaireModel>(this.config.getApiRoute('api/v3/client-portal/properties/' + property_id + '/questionnaires/'+questionnaire_id)).pipe(
      map(data => {
        return data;
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err.error.message);
      }));
  }
  public DeleteQuestionnaire(property_id: string, questionnaire_id: string): Observable<{}> {
    return this.api.delete(this.config.getApiRoute('api/v3/client-portal/properties/' + property_id + '/questionnaires/'+ questionnaire_id)).pipe(
      map(data => {
        return data;
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err.error.message);
      }));
  }

  public SaveQuestionnaire(model: QuestionnaireModel): Observable<QuestionnaireModel> {
    if (model.id) {
      return this.api.put<QuestionnaireModel>(this.config.getApiRoute('api/v3/client-portal/properties/' + model?.property_id + '/questionnaires/'+ model?.id), model).pipe(
        map(data => {
          return data;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(err.error.message);
        }));
    }
    else {
      return this.api.put<QuestionnaireModel>(this.config.getApiRoute('api/v3/client-portal/properties/' + model?.property_id + '/questionnaires'), model).pipe(
        map(data => {
          return data;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(err.error.message);
        }));
    }
  }

  public DownloadQuestionnaire(property_id: string,questionnaire_id: string): Observable<FileModel> {
    return this.api.get<FileModel>(this.config.getApiRoute('api/v3/client-portal/properties/' + property_id + '/questionnaires/'+questionnaire_id+'/export-csv')).pipe(
      map(data => {
        return data;
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err.error.message);
      }));
  }

}
